<template>
  <!-- <div class="container" :class="skin">
    <div class="row">
      <h1 v-if='title' class="center-align">{{ title }}</h1>
      <p v-if='msg'>{{ msg }} <a  class="url" target="_blank" :href="url">{{url}}</a></p>
      <div class="divider"></div>
      <div v-bind:class="{ hidden: !qrstring }">
        <qrcode-vue :value="qrstring" :size="256" level="H" class="col s12 m6"></qrcode-vue>
        <div class="col s12 m6">
          <span class="center-align" style="font-size: 1.6rem;">{{ $t("SETTINGS-LINK.CODE") }}</span><br>
          <span style="font-size: 1.6rem; font-weight: bold; user-select: text;">{{qrstring}}</span><br><br>
          <icon name="spinner" spin :scale="6"></icon>
        </div>
      </div>
    </div>
  </div> -->

  <div class="container">
    <h1>Login</h1>
    <div id="wrapper-login"  v-bind:class="{ hidden: !qrstring }">
      <div v-if="$store.getters.getData.is_app_mobile" class="box">
         <qrcode-vue :value="qrstring" :size="220" level="H"></qrcode-vue>
         <p>{{$t("SETTINGS-LINK.MSG1")}}</p>
      </div>
      <div class="box">
        <p style="font-weight: bold; line-height: 1rem;">{{ $t("SETTINGS-LINK.CODE") }}</p>
        <p style="line-height: 1rem; margin-bottom: 7rem; font-size: 3rem">{{qrstring}}</p>
        <p>{{$t("SETTINGS-LINK.MSG2")}}<span class="url">{{url}}</span></p>
      </div>
    </div>
    <hr v-if="$store.getters.getData.is_app_mobile" class="hr-text" data-content="OR"/>
  </div>

</template>

<script>
import Fingerprint2 from 'fingerprintjs2'
import QrcodeVue from 'qrcode.vue'
import { enviroment } from '@/utils/constants'
import Loader from '@/components/Loader'
import { setLocation, getLocation } from '@/utils/helper-functions'
let auth = require('@/services/auth.js')

export default {
  name: 'Login',
  components: { 'app-loader': Loader, QrcodeVue },
  props: {
    title: { default: '' },
    msg: { default: '' },
    skin: {type: String, default: 'light'},
    redirect: { default: true }
  },
  data () {
    return {
      device: null,
      qrstring: ''
    }
  },
  mounted: function () {
    this.count = 24 // lammadas max.
    this.device = this.$store.getters.device
    if (this.device) {
      this.getGeolocation()
    } else {
      new Fingerprint2().get((uuid) => {
        this.device = {
          available: true,
          platform: 'browser',
          uuid: uuid
        }
        this.$store.commit('setDevice', this.device)
        this.getGeolocation()
      })
    }
  },
  methods: {
    keyBack () { this.$router.go(-1) },
    getGeolocation () {
      let location = getLocation(this.$store.getters.getData.is_zones)
      if (location) {
        this.setDevice(location.lat, location.lon)
      } else {
        if (navigator.geolocation && !window.webOS) {
          // obtenemos geolocalización (LG no lo permite)
          let options = {
            enableHighAccuracy: false,
            timeout: 8000,
            maximumAge: Infinity
          }
          navigator.geolocation.getCurrentPosition(
            (position) => {
              setLocation({lat: position.coords.latitude, lon: position.coords.longitude})
              this.setDevice(position.coords.latitude, position.coords.longitude)
            },
            () => { this.setDevice(0, 0) },
            options)
        } else {
          this.setDevice(0, 0)
        }
      }
    },
    setDevice (lat, long) {
      lat = parseFloat(lat).toFixed(10)
      long = parseFloat(long).toFixed(10)

      if (this.device.platform === 'tv-webos' || this.device.platform === 'sectv-tizen') {
        // TV (Lg or Samsung)
        let type = ''
        if (this.device.platform === 'tv-webos') {
          type = 'LG'
        } else if (this.device.platform === 'sectv-tizen') {
          type = 'SAM'
        }

        let name = this.device.manufacturer + '/' + this.device.model
        let uuid = this.device.uuid
        let system = this.device.platform + '/' + this.device.version

        // guardamos u obtenemos device
        auth.setDevice(lat, long, name, type, uuid, system).then(response => {
          this.setLink(response.data)
        })
      } else if (this.device.platform === 'browser') {
        // browser
        let userAgent = navigator.userAgent.substring(0, 150)
        // guardamos u obtenemos device
        auth.setDevice(lat, long, 'Browser', 'WEB', this.device.uuid, userAgent).then(response => {
          this.setLink(response.data)
        })
      } else { console.error('Unknown Device') }
    },
    setLink (dataDevice) {
      auth.setLink(dataDevice).then(response => {
        // generamos código qr
        this.qrstring = response.data.code
        // el dispositivo no esta vinculado
        if (!response.data.is_link) {
          this.getLink(response.data.code)
        }
      })
    },
    getLink (code) {
      auth.getLink(code).then(response => {
        if (response.data.access_key !== '' && response.data.refresh_key !== '') {
          // logeamos nuevo usuario
          this.deleteLink(response.data)
        } else if (this.device) {
          // esperamos usuario (recargamos a los 5s)
          if (this.count > 0) {
            this.count--
            this.timeout = setTimeout(() => { this.getLink(response.data.code) }, 5000)
          } else {
            this.keyBack()
          }
        }
      }).catch(() => {
        this.keyBack()
      })
    },
    deleteLink (dataLink) {
      // guardamos ubicación
      let location = getLocation(this.$store.getters.getData.is_zones)
      if (!location) { setLocation({lat: dataLink.latitude, lon: dataLink.longitude}) }

      // desactivamos código QR server
      auth.deleteLink(dataLink.code).then(response => {
        this.loginUser(dataLink)
      })
    },
    loginUser (data) {
      // remove token
      auth.logout(this.$store.getters.getToken)
      // save token
      this.$store.commit('setToken', {'accessToken': data.access_key, 'refreshToken': data.refresh_key})
      // login
      auth.getUser().then(response => {
        this.$store.commit('setUser', response.data['results'][0])
        this.redirect ? this.$router.push({name: 'content'}) : this.$emit('onLogin')
      }).catch((error) => {
        console.error(error.response)
      })
    }
  },
  computed: {
    url: function () {
      if (this.$store.getters.getData.login_url) {
        return this.$store.getters.getData.login_url
      }
      let env = enviroment
      if (enviroment === 'api' || enviroment === 'api-pinko') { env = 'portal' }
      return 'https://' + env + '.interactvty.com/tv/' + this.$store.getters.getData.name + '/link-device/'
    }
  },
  beforeDestroy: function () {
    this.device = null
    clearTimeout(this.timeout)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>

.container
  width: 95%
  border-radius: 2px
  text-align: center
  margin-bottom: 2rem

  h1
    font-size: 2.6rem

  p
    font-size: 1.4rem

  .url
    font-weight: bold
    color: inherit

#wrapper-login
  display: flex
  display: -webkit-flex
  flex-direction: row
  justify-content: space-between

  width: 100%
  height: 100%
  color: #454545

  .box
    flex: 1
    align-self: flex-end
    text-align: center
    padding: 1rem
    font-size: 1.6rem

.hr-text
  line-height: 1em
  position: relative
  outline: 0
  border: 0
  // color: black
  text-align: center
  height: 1.5em
  // opacity: .5

  font-size: 1.6rem

  &:before
    content: ''
    // use the linear-gradient for the fading effect
    // use a solid background color for a solid bar
    background: linear-gradient(to right, transparent, #818078, transparent)
    position: absolute
    left: 0
    top: 50%
    width: 100%
    height: 2px

  &:after
    content: attr(data-content)
    position: relative
    display: inline-block
    // color: black

    padding: 0 .5em
    line-height: 1.5em
    // this is really the only tricky part, you need to specify the background color of the container element...
    // color: #818078
    color: #454545
    background-color: #fcfcfa

// .container
//   width: 90%;
//   border-radius: 2px

//   .divider
//     margin-bottom: 20px

//   .col
//     text-align: center

//   h1
//     font-size: 2.6rem

//   p
//     font-size: 1.1rem

// .hidden
//   visibility: hidden

// .url
//   font-weight: bold
//   color: inherit;
</style>



// WEBPACK FOOTER //
// src/components/Login.vue